import {createFormContext} from "@mantine/form";
import {CompanyEntity, SiteAssignmentStrategy, TransportCategory} from "@ots-frontend/ots-data";

export interface SiteAssignmentCompanyAssocFormValues {
  company: CompanyEntity | string;
  normalRank: number;
  serviceRank: number;
}

export interface CompanySiteAssignmentFormValues {
  strategy: SiteAssignmentStrategy;
  assocs: SiteAssignmentCompanyAssocFormValues[];
  entityType?: string
  entityIds?: string[]
  category?: TransportCategory
}

export interface CompanySiteAssignmentFormFieldValues {
  strategy: string;
  normalCompanies: { id: string }[];
  serviceCompanies: { id: string }[];
  entityType?: string
  entityIds?: string[]
  category?: string
}

export const [
  CompanySiteAssignmentFormProvider,
  useCompanySiteAssignmentFormContext,
  useCompanySiteAssignmentForm
] = createFormContext<CompanySiteAssignmentFormFieldValues>();
